
import Devices from "../../../assets/duotone/Devices.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DevicesIcon({ className, dataTestid = "DevicesIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Devices data-testid={dataTestid} className={classes} {...rest} />
  );
}
